<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'uploadimgs',
})
</script>
<template>
  <a-upload
      v-model:file-list="fileList"
      :action="action"
      list-type="picture-card"
      :maxCount="props.max"
      accept=".jpg,.jpeg,.png,.gif,.bmp"
      @change="change"
    >
      <div v-if="fileList.length < max">
        <plus-outlined />
        <div style="margin-top: 8px">上传图片</div>
      </div>
    </a-upload>
</template>
<script setup lang="ts" name="uploadimgs">
import { PlusOutlined } from '@ant-design/icons-vue'
import { ref,defineEmits,defineProps,watch,onMounted } from 'vue'
import { baseURL } from '@/utils/util'
import type { UploadProps } from 'ant-design-vue'
  const props=defineProps({
      value:{type:Array},
      max:{type:Number},
  })
  const first=ref<boolean>(true)
  const action=ref<string>(baseURL+'/Upload/UploadWangEditor')
  const fileList=ref<UploadProps['fileList']>([])
  const emits= defineEmits(['update:value'])
  const change=(f:any)=>{
    fileList.value=f.fileList
    var list=[]
    f.fileList.forEach(e => {
      if(e.response&&e.response.state==1){
        if(Array.isArray(e.response.data)){
            list.push(e.response.data[0].href)
        }else{
            list.push(e.response.data.href)
        }
      }
    })
    emits('update:value',list)
  }
  onMounted(()=>{
    if(props.value){
    var list=[]
      props.value.forEach(e=>{
        var o:any={
          url:baseURL+e,
          thumbUrl:baseURL+e,
          status:'done',
          response:{state:1,data:{url:baseURL+e,href:e}}
        }
        list.push(o)
      })
      fileList.value=list
      }
  })

</script>
